import { IUpdateContratoArquivoUseCase } from "../../../presentation/useCases/update/update_contrato_arquivo_use_case";

import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

export class UpdateContratoArquivoUseCase implements IUpdateContratoArquivoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async updateContratoArquivo(
    IdContratoArquivo: number,
    IdContrato: number,
    Descricao: string | null,
    Nome: string | null,
    Arquivo: File | null,
    Obsoleto: number | null,
    DataVencimento: Date | null,
    limparArquivo1: boolean | null,
  ): Promise<void> {
    await this.repository.updateContratoArquivo(
      IdContratoArquivo,
      IdContrato,
      Descricao,
      Nome,
      Arquivo,
      Obsoleto,
      DataVencimento,
      limparArquivo1
    );
  }
}
